export default {
  Default: `.pdf,.doc,.docx
              ,.png,.jpg,.jpeg,.bmp
              ,.mp3,.mp4,.m4a
              ,.xls,.xlsx,.ppt,.pptx,.odp,.xmind,.mmap,.zip,.ods,.csv
              ,.7z,.rar,.html,.htm,.dwg,.dwf,.edb,.e2k,.msg,.odt,.rtf,.gif,.txt`,
  ImageOnly: '.png,.jpg,.jpeg,.bmp',
  ImageAndVideo: '.png,.jpg,.jpeg,.bmp,.mp3,.mp4,.m4a',
  AudioAndVideo: '.mp3,.mp4,.m4a',
  AttachFile: '.png,.jpg,.jpeg,.bmp,.doc,.docx,.pdf',
  Excel: '.xlsx,.xls',
  Pdf: '.pdf',
  Doc: '.doc',
  Docx: '.docx',
  Ott: '.ott',
  Odt: '.odt',
  Xls: '.xls',
  Xlsx: '.xlsx',
  Ppt: '.ppt',
  Pptx: '.pptx',
  Odp: '.odp',
  Ods: '.ods',
  Xml: '.xml',
  Jpeg: '.jpeg',
  Jpg: '.jpg',
  Bmp: '.bmp',
  Png: '.png',
  Jfjf: '.jfif',
  Mp4: '.mp4',
  M4a: '.m4a',
  Mp3: '.mp3',
}
